import React, { useEffect, useState } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { TextField } from '@mui/material';

const AddressAutocomplete = ({ onSelect, value, required = false, variant = 'standard', ...rest }) => {
  const [textValue, setTextValue] = useState(value);
  const [placeValue, setPlaceValue] = useState('');
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    onPlaceSelected: (place) => {
      onSelect(place);
      setPlaceValue(place.formatted_address);
      setTextValue(place.formatted_address);
    },
    options: {
      types: ['address'],
      fields: ['address_components', 'formatted_address'],
      componentRestrictions: { country: 'us' },
    },
  });

  return (
    <TextField
      required={required}
      variant={variant}
      value={textValue}
      onChange={({ target }) => setTextValue(target.value)}
      onBlur={() => setTextValue(placeValue)}
      fullWidth
      id="address-input"
      label="Address"
      inputRef={ref}
      {...rest}
    />
  );
};

export default AddressAutocomplete;
